import React from 'react';

interface MessageBoxProps {
    children: React.ReactNode;
    error?: boolean;
}

const MessageBox: React.FC<MessageBoxProps> = ({ children, error = false }) => {
    const baseClass = `mb-5 w-full self-start rounded-lg border border-transparent bg-tertiary p-5 text-left text-base leading-6${error ? ' error-msg' : ''}`;
    const errorStyle = error ? { backgroundColor: '#f2dedf', color: '#e13b36' } : undefined;
    return (
        <div className={baseClass} style={errorStyle}>
            {children}
        </div>
    );
};

export default MessageBox;
